
import { ScorecardEntity } from '@/entities/scorecard'
import UpDownArrow from '@/components/UpDownArrow.vue'
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 's-vuex-class'

@Component({
    components: {
        UpDownArrow,
    },
})
export default class ScorecardNPS extends Vue {
    @Getter
    scorecard!: ScorecardEntity
}
